var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm-8.14-7.855h3.432V13.1H7.859v11.045zM7.54 9.52a2.001 2.001 0 104.002 0 2.001 2.001 0 00-4.003 0zm13.18 14.625h3.43v-6.058c0-2.974-.642-5.261-4.118-5.261-1.67 0-2.79.915-3.248 1.783h-.046V13.1h-3.293v11.045h3.43v-5.464c0-1.44.275-2.836 2.06-2.836 1.761 0 1.785 1.648 1.785 2.93v5.37z",
    fill: "#fff"
  })));
}
export default SvgLinkedinIcon;